import React, { PureComponent } from 'react'
import { Grid, Paper, ListItem, MenuItem } from '@material-ui/core'
import {
  EditableTextField,
  EditableSelect,
  EditableSwitch,
  EditableReactSelect,
  EditableDateInput,
} from '../common/EditableComponents'
import moment from 'moment'
import { convertArrayToOptions } from '../../utils/array'

export default class EmployeeInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  onChange = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value
    this.props.onChange(key, value)
  }

  onChangeDate = (key) => (e) => {
    this.props.onChange(key, e.valueOf())
  }

  onChangePhone = (e, key) => {
    this.props.onChange(key, e)
  }

  onChangeApplyCustomDiscount = (key, isCheckBox, isAdminOrManagerRole) => (e) => {
    if (!isAdminOrManagerRole) {
      const value = isCheckBox ? e.target.checked : e.target ? e.target.value : e.valueOf()
      this.props.onChange(key, value)
    }
  }

  onChangeAllshops = (isAdminEmployee) => (event) => {
    if (this.props.editMode && !isAdminEmployee) {
      const { shops = [] } = this.props || {}

      let updatedShops = []
      if (event.target.checked) {
        shops.map((shop) => {
          updatedShops = [...updatedShops, shop.id]
        })
      } else {
        updatedShops = []
      }

      this.props.onChange('shops', updatedShops)
    }
  }

  onChangeShops = (shopId, isAdminEmployee) => (event) => {
    if (this.props.editMode && !isAdminEmployee) {
      const { shops = [] } = this.props.data || {}

      let updatedShops = [...shops]

      if (event.target.checked) {
        updatedShops = [...updatedShops, shopId]
      } else {
        const shopIndex = updatedShops.findIndex((shop) => shop === shopId)
        updatedShops.splice(shopIndex, 1)
      }

      this.props.onChange('shops', updatedShops)
    }
  }

  onChangeAddress = (key) => (e) => {
    const { data } = this.props
    const { address } = data

    let newAddress = { ...address }

    newAddress = {
      ...newAddress,
      [key]: e.target.value,
    }

    if (key === 'country') {
      newAddress = {
        ...newAddress,
        state: '',
      }
    }
    this.props.onChange('address', newAddress)
  }

  onSelectChange = (configs) => {
    let value = (configs && configs.length && configs.map((config) => config.value)) || []
    this.props.onChange('appAccessList', value)
  }
  onSelectChangeTerminal = (key, input) => {
    this.props.onChange(key, input && input.value)
  }

  render() {
    const {
      data = {},
      editMode = false,
      roles = [],
      errors = {},
      availableApps = [],
      vehicles = [],
      shops = [],
      isSameUser = false,
    } = this.props
    const employeeRole = data && data.roleId ? roles.find((role) => role.id === data.roleId) : ''
    const employeeVehicle =
      data && data.defaultVehicleId
        ? vehicles.find((vehicle) => vehicle.id === data.defaultVehicleId)
        : ''
    const Id = (data.id && data.id.length && data.id.substr(data.id.length - 5)) || ''
    const isEmployee = data && data.id ? true : false
    const configOptions = [
      { label: 'Authentication App', value: 'AuthenticationApp' },
      { label: 'Retail', value: 'Retail' },
      { label: 'Distro', value: 'Distribution' },
      { label: 'Grow', value: 'Grow' },
    ]

    if (availableApps && availableApps.length > 0 && availableApps.indexOf('Dispatch') >= 0) {
      configOptions.push({ label: 'Dispatch', value: 'Dispatch' })
    }

    const selectedConfigs =
      data &&
      data.appAccessList &&
      data.appAccessList.length &&
      data.appAccessList.map((access) =>
        access === 'Distribution'
          ? { label: 'Distro', value: access }
          : { label: access.split(/(?=[A-Z])/).join(' '), value: access },
      )
    let { appAccessList = [] } = data || {}
    appAccessList = appAccessList.map((access) => (access === 'Distribution' ? 'Distro' : access))

    const isAdminOrManagerRole =
      roles &&
      roles.find(
        (dbRole) =>
          dbRole.id === data.roleId && (dbRole.name == 'Admin' || dbRole.name == 'Manager'),
      )
    const isAdminEmployee =
      roles && roles.find((dbRole) => dbRole.id === data.roleId && dbRole.name == 'Admin')

    let terminalOptions = convertArrayToOptions(this.props.terminals.filter((term) => term.active))
    let selectedTerminal =
      terminalOptions.find((term) => term.value === data.assignedTerminalId) || {}
    let info = { label: 'Unassigned', value: 'Unassigned' }
    terminalOptions.unshift(info)

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              {isEmployee && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      ID
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={Id}
                        editMode={false}
                        value={Id}
                        onChange={this.onChange('firstName')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {isEmployee && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Internal ID
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.id || ''}
                        editMode={false}
                        value={data.id || ''}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {isEmployee && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Status
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={data.disabled}
                        onChange={this.onChange('disabled')}
                        valueToRender={data.disabled ? 'Inactive' : 'Active'}
                        editMode={editMode && !isSameUser}
                      >
                        <MenuItem value={false}>Active</MenuItem>
                        <MenuItem value={true}>Inactive</MenuItem>
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    First Name*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.firstName || ''}
                      editMode={editMode}
                      value={data.firstName || ''}
                      onChange={this.onChange('firstName')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.firstName}
                      helperText={errors.firstName}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Last Name*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.lastName || ''}
                      editMode={editMode}
                      value={data.lastName}
                      onChange={this.onChange('lastName')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.lastName}
                      helperText={errors.lastName}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              {isEmployee && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Access Config
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableReactSelect
                        multi={true}
                        value={selectedConfigs}
                        onChange={this.onSelectChange}
                        valueToRender={appAccessList.join(', ') || ''}
                        editMode={editMode}
                        clearable={true}
                        options={
                          configOptions.length !== selectedConfigs.length ? configOptions : []
                        }
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Role*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={editMode ? data.roleId : (employeeRole && employeeRole.name) || ''}
                      onChange={this.onChange('roleId')}
                      valueToRender={
                        editMode ? data.roleId : (employeeRole && employeeRole.name) || ''
                      }
                      editMode={editMode}
                      error={errors.roleId}
                    >
                      {roles.map((role, index) => {
                        return (
                          <MenuItem key={role.id} value={role.id}>
                            {role.name}
                          </MenuItem>
                        )
                      })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Packer
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSwitch
                      valueToRender={data.packer ? 'Yes' : 'No'}
                      editMode={editMode}
                      checked={data.packer}
                      onChange={this.onChange('packer', true)}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Driver
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSwitch
                      valueToRender={data.driver ? 'Yes' : 'No'}
                      editMode={editMode}
                      checked={data.driver}
                      onChange={this.onChange('driver', true)}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              {data.driver ? (
                <div>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Driver's License*
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableTextField
                          valueToRender={data.driversLicense || ''}
                          editMode={editMode}
                          value={data.driversLicense}
                          onChange={this.onChange('driversLicense')}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={errors.driversLicense}
                          helperText={errors.driversLicense}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        License Expiration
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableDateInput
                          className="emp-date-picker"
                          isValidDate={this.isValidDate}
                          valueToRender={
                            (!!data.dlExpirationDate &&
                              moment(parseInt(data.dlExpirationDate)).format('MM/DD/YYYY')) ||
                            ''
                          }
                          editMode={editMode}
                          value={
                            (!!data.dlExpirationDate &&
                              moment(parseInt(data.dlExpirationDate)).format('MM/DD/YYYY')) ||
                            ''
                          }
                          onChange={this.onChangeDate('dlExpirationDate')}
                          type="text"
                          closeOnSelect={true}
                          timeFormat={false}
                          inputProps={{ placeholder: 'MM/DD/YYYY' }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Vehicle*
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={
                            editMode
                              ? (data.driver && data.defaultVehicleId) || ''
                              : (employeeVehicle && employeeVehicle.name) || ''
                          }
                          onChange={this.onChange('defaultVehicleId')}
                          valueToRender={
                            editMode
                              ? (data.driver && data.defaultVehicleId) || ''
                              : (employeeVehicle && employeeVehicle.name) || ''
                          }
                          editMode={editMode}
                          error={errors.defaultVehicleId}
                        >
                          <MenuItem>Select a vehicle</MenuItem>
                          {vehicles &&
                            vehicles.map((vehicle) => {
                              return (
                                <MenuItem key={vehicle.id} value={vehicle.id}>
                                  {vehicle.name}
                                </MenuItem>
                              )
                            })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Occupational License Number
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableTextField
                          valueToRender={data.occupationLicenseNumber || ''}
                          editMode={editMode}
                          value={data.occupationLicenseNumber || ''}
                          onChange={this.onChange('occupationLicenseNumber')}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </div>
              ) : null}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Custom Discounts
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSwitch
                      valueToRender={data.canApplyCustomDiscount ? 'Yes' : 'No'}
                      editMode={editMode}
                      checked={!!isAdminOrManagerRole || !!data.canApplyCustomDiscount}
                      onChange={this.onChangeApplyCustomDiscount(
                        'canApplyCustomDiscount',
                        true,
                        !!isAdminOrManagerRole,
                      )}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Assigned Shop(s)
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Grid alignItems="center" container>
                      <EditableSwitch
                        editMode={true}
                        disabled={!editMode}
                        checked={
                          !!isAdminEmployee ||
                          !!((data.shops && data.shops.length) === (shops && shops.length))
                        }
                        onChange={this.onChangeAllshops(!!isAdminEmployee)}
                      />
                      <strong>Add All Shops</strong>
                    </Grid>
                    {shops.map((shop) => {
                      return (
                        <Grid alignItems="center" container key={shop.id}>
                          <EditableSwitch
                            editMode={true}
                            disabled={!editMode}
                            checked={
                              !!isAdminEmployee ||
                              !!(data.shops && data.shops.find((shopId) => shop.id === shopId))
                            }
                            onChange={this.onChangeShops(shop.id, !!isAdminEmployee)}
                          />
                          {shop.name}
                        </Grid>
                      )
                    })}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Assigned Terminal
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableReactSelect
                      value={
                        !!data.assignedTerminalId &&
                        terminalOptions.find((term) => term.value === data.assignedTerminalId)
                      }
                      onChange={(data) => this.onSelectChangeTerminal('assignedTerminalId', data)}
                      valueToRender={
                        selectedTerminal && selectedTerminal.label
                          ? selectedTerminal && selectedTerminal.label
                          : 'No Terminal Assigned'
                      }
                      editMode={editMode}
                      options={terminalOptions}
                      multi={false}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/EmployeeInfo.js